export const flexWrapperStyle = { display: 'flex' };

export const firstColumnFieldStyle = {
  paddingRight: '20px',
  width: '50%',
};

export const secondColumnFieldStyle = {
  width: '50%',
};

export const flexEndFieldStyle = {
  ...secondColumnFieldStyle,
};
